var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgVizlaIconLight(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 64.37 37.23",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#f2e4d8;}.cls-2{fill:#FFFFFF;}.cls-3{fill:#60bfc0;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "32.18 33.52 14.83 23.5 11.63 25.36 32.18 37.23 52.74 25.36 49.54 23.5 32.18 33.52"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "32.18 26.73 14.95 16.78 11.63 18.7 32.18 30.57 52.74 18.7 49.41 16.78 32.18 26.73"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "51.73 22.25 54.91 24.11 64.37 18.64 55.29 13.38 51.98 15.29 57.97 18.64 51.73 22.25"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "12.68 22.27 9.49 24.13 0 18.64 9.08 13.39 12.29 15.24 6.41 18.64 12.68 22.27"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "52.74 11.91 32.18 0 11.63 11.91 32.18 23.78 52.74 11.91"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgVizlaIconLight);
export default __webpack_public_path__ + "static/media/Vizla-icon-light.2b28a68aff1779efae1ef14072a9573f.svg";
export { ForwardRef as ReactComponent };